import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose, Type } from 'class-transformer';
import { RepairFormulaInterface } from '../interfaces/repair-formula.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { RepairBumperPaymentTypeEnum } from '../enums/repair-bumper-payment-type.enum';
import { RepairPaymentTypeEnum } from '../enums/repair-payment-type.enum';
import { RepairResourceTypeEnum } from '../enums/repair-resource-type.enum';
import { RepairInterface } from '../../repair/interfaces/repair.interface';
import { IsBoolean } from 'class-validator';

@Exclude()
export class RepairFormulaDto
  extends CommonEntityDto
  implements RepairFormulaInterface
{
  @ApiProperty({
    title: 'Repair ID',
  })
  @Expose()
  repairId!: string;

  @ApiProperty({
    title: 'Repair Entity',
  })
  @Expose()
  repair?: RepairInterface;

  @ApiProperty({
    title: 'Repair Resource Type Enum',
    nullable: true,
  })
  @Expose()
  repairResourceType!: RepairResourceTypeEnum;

  @ApiProperty({
    title: 'Repair Payment Type Enum',
    nullable: true,
  })
  @Expose()
  repairPaymentType!: RepairPaymentTypeEnum;

  @ApiProperty({
    title: 'Repair Payment Type Enum',
    nullable: true,
  })
  @Expose()
  repairBumperPaymentType!: RepairBumperPaymentTypeEnum;

  @ApiProperty({
    type: 'boolean',
    default: true,
    title: 'Active?',
    description: 'True if Repair Formula is active',
  })
  @IsBoolean()
  @Type(() => Boolean)
  @Expose()
  active!: boolean;
}
